export default __webpack_public_path__ + "static/media/USUARIO_BENEFICIOS.077afc44.png";